export const INTERNATIONAL_DRIVING_PERMIT_FORM_NAME = 'internationalDrivingPermitForm' as const;
